import { render } from "./C404Page.vue?vue&type=template&id=60e2abad&scoped=true"
import script from "./C404Page.vue?vue&type=script&lang=js"
export * from "./C404Page.vue?vue&type=script&lang=js"

import "./C404Page.vue?vue&type=style&index=0&id=60e2abad&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e2abad"]])

export default __exports__